import { Component } from '@angular/core';
import { FavouriteProductIconComponent } from 'gung-standard';

@Component({
  selector: 'app-hl-display-favourite-product-icon',
  standalone: false,
  templateUrl: './hl-display-favourite-product-icon.component.html',
  styleUrl: './hl-display-favourite-product-icon.component.css'
})
export class HlDisplayFavouriteProductIconComponent extends FavouriteProductIconComponent {
  onHostClick(event: Event) {
    event.stopPropagation();
    event.preventDefault();
    this.toggle();
  }
}
